// export const MANDATORY_FIELDS = [
//     "gender",
//     "last_name",
//     "first_name",
//     "date_of_birth",
//     "email",
//     "country_code",
//     "main_phone",
//     "nationality",
//     "dual_nationality",
//     "location",
//     "higher_education_level",
//     "discipline",
//     "experience_years",
//     "project_phase",
//     "activities",
//     "technical_disciplines",
//     "cv_origin",
//     "sector",
//     "subsector"
//   ];

  export const MANDATORY_FIELDS = [
  "gender",
  "last_name",
  "first_name",
  "date_of_birth",
  "email",
  "phone",                     // correct field
  "nationality",
  "location",
  "highest_education_level",   // correct field name
  "experience_level",          // correct field name
  "project_phase",
  "sector_id",                 // correct field
];

export const ALL_PROFILE_FIELDS = [
  // Personal Info
  { key: 'first_name',               label: 'First Name',            section: 'Personal' },
  { key: 'last_name',                label: 'Last Name',             section: 'Personal' },
  { key: 'email',                    label: 'Email',                 section: 'Personal' },
  { key: 'phone',                    label: 'Phone',                 section: 'Personal' },
  { key: 'gender',                   label: 'Gender',                section: 'Personal' },
  { key: 'location',                 label: 'Location',              section: 'Personal' },
  { key: 'date_of_birth',            label: 'Date of Birth',         section: 'Personal' },
  { key: 'nationality',              label: 'Nationality',           section: 'Personal' },
  // { key: 'dual_nationality',         label: 'Dual Nationality',      section: 'Personal' },
  // { key: 'languages',               label: 'Languages',             section: 'Personal' },

  // Sector Info
  { key: 'sector_id',               label: 'Sector',                section: 'Sector' },
  { key: 'sector_name',             label: 'Sector Name',           section: 'Sector' },
  { key: 'sub_sectors',             label: 'Sub Sectors',           section: 'Sector' },
  { key: 'discipline_names',        label: 'Technical Disciplines', section: 'Sector' },
  { key: 'activities',              label: 'Activities',            section: 'Sector' },
  { key: 'project_phase',           label: 'Project Phases',        section: 'Sector' },

  // Career
  { key: 'preferred_location',      label: 'Preferred Location',    section: 'Career' },
  { key: 'availability_notice_period', label: 'Availability',       section: 'Career' },
  { key: 'highest_position',        label: 'Highest Position',      section: 'Career' },
  { key: 'years_of_experience',     label: 'Years of Experience',   section: 'Career' },

  // Skills
  { key: 'skills',                  label: 'Skills',                section: 'Skills' },

  // Education
  { key: 'education_details',       label: 'Education',             section: 'Education' },

  // Experience
  { key: 'experience_intervals',    label: 'Experience',            section: 'Experience' },

  // Resume
  { key: 'file_path',              label: 'Resume Uploaded',        section: 'Resume' },
];

export const COMPLETION_FIELDS = [
  { key: 'first_name',           label: 'First Name',         section: 'Personal' },
  { key: 'last_name',            label: 'Last Name',          section: 'Personal' },
  { key: 'location',             label: 'Current Location',   section: 'Personal' },
  { key: 'phone',                label: 'Phone Number',       section: 'Personal' },
  { key: 'gender',               label: 'Gender',             section: 'Personal' },
  { key: 'languages',            label: 'Languages',          section: 'Personal' },
  { key: 'nationality',          label: 'Nationality',        section: 'Personal' },
  { key: 'date_of_birth',        label: 'Date of Birth',      section: 'Personal' },
  { key: 'sector_id',            label: 'Sector',             section: 'Sector'   },
  { key: 'project_phase',        label: 'Project Phase',      section: 'Sector'   },
  { key: 'experience_intervals', label: 'Experience',         section: 'Experience' },
  { key: 'education_details',    label: 'Education',          section: 'Education' },
];

export const ACTIVE_STATUSES = ["Open Req", "Relaunch-open request", "Anticipation", "Interviewing", "Offer made", "Waiting for feedback", "On Hold", "Pre-Sales"];

  export const CLOSED_STATUSES = ["Closed - Won", "Closed - Lost"];

  export const PROFICIENCY_LEVELS = [
    { value: 'basic', label: 'Basic' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' },
    { value: 'fluent', label: 'Fluent' },
    { value: 'native', label: 'Native' }
  ];

  export const getInitials = (first, last) => {
    const firstInitial =
      first && typeof first === 'string' && first.length > 0
        ? first[0].toUpperCase()
        : '';
    const lastInitial =
      last && typeof last === 'string' && last.length > 0
        ? last[0].toUpperCase()
        : '';
    return `${firstInitial}${lastInitial}`;
  };

  export const generateRequestId = () => `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  export const toTitleCase = (str) =>
    str?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());